/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createDivide } from '../../factoriesNumber.js';
export var divideDependencies = {
  typedDependencies,
  createDivide
};